// extracted by mini-css-extract-plugin
module.exports = {"invalid":"Editor_invalid__pyag1"};